module.exports = __webpack_public_path__ + "img/help1.27c2d4c4.png";